<template>
  <div data-aos="fade-left" class="col-md-2 col-4 card-container">
    <div
      class="wrapper d-flex flex-column centered"
      :class="{
        light: !isDarkMode,
      }">
      <img
        :src="
          require(`../../assets/skill/${iconName ?? name?.toLowerCase()}.webp`)
        "
        :alt="iconName ?? name?.toLowerCase()"
        class="image"
        :class="{
          'image-padding': addImagePadding,
          'image-radius': addRadius,
        }" />
      <p>{{ name }}</p>
    </div>
  </div>
</template>

<script setup lang="ts">
import {defineProps, ref, watch} from 'vue';
import {useStore} from 'vuex';

defineProps({
  iconName: String,
  name: String,
  addImagePadding: Boolean,
  addRadius: Boolean,
});

const store = useStore();
const isDarkMode = ref(store.state.isDarkMode);

watch(
  () => store.state.isDarkMode,
  newValue => {
    isDarkMode.value = newValue;
  },
);
</script>

<style lang="scss" scoped>
.card-container {
  padding: 5px !important;

  .wrapper {
    width: 100%;
    border-radius: 10px;
    box-shadow: 0 6px 8px rgba(0, 0, 0, 0.2);
    transition: 0.3s;
    padding-top: 10px;
    background-color: var(--dark-mode-secondary-bg);
    transition: transform 0.2s ease-in-out;

    @media screen and (min-width: 576px) {
      &:hover {
        transform: scale(1.05);
      }
    }

    &.light {
      background-color: var(--light-mode-secondary-bg);
      box-shadow: 0 2px 2px rgba(0, 0, 0, 0.2);
    }

    img {
      height: 50px;
    }
    .image-padding {
      width: 50px;
      padding: 2px;
      border-radius: 50%;
      background-color: rgb(236, 236, 236);
    }
    .image-radius {
      width: 50px;
      border-radius: 10%;
    }

    p {
      text-align: center;
      margin-top: 10px;
    }
  }
}

@media screen and (max-width: 360px) {
  .card-container {
    width: 50% !important;
  }
}
</style>
